
<template>
    <div>
        <table v-if="dataRow">
          <template v-for="(col, colIndex) in dataRow.cols">

            <template v-if="tableData.cols[colIndex] && !tableData.cols[colIndex].hide" >
              <td
                  v-if="col && !col.hide && (col.type === 'component')"

                  :colspan="col.colspan || 1"
                  class="menu-table-cell"

                  :ref="'col_' + index + '_' + colIndex"
              >
                <component
                    :ref="'colComponent_' + index + '_' + colIndex"
                    v-model="col.value" v-bind:is="col.componentName"
                    v-bind="col.props" v-bind:tableData="tableData" v-bind:dataRow="dataRow"></component>
              </td>
              <td
                  v-else
                  v-on=" (!col.noCallback && col.callback) ? { click: col.callback.bind(col, dataRow, index)} : {} "
                  style="cursor: pointer;"
                  :data-type="col.type"
                  :colspan="col.colspan || 1"
                  class="menu-table-cell"

                  :ref="'col_' + index + '_' + colIndex"
              >
                <!--
                <span>
                    <component :ref="'colComponent_' + index + '_' + colIndex" :is="col.htmlComponent"></component>
                </span>
                -->
                <span v-html="col.html"/>

              </td>

            </template>
          </template>
        </table>
        <div v-else v-html="title"></div>
        <component 
                    v-if="displayComponent"
                    v-bind="displayComponentProps"
                    v-bind:is="displayComponent"
                    v-show="showDisplayComponent"
                    :dataRow="dataRow"
                    :tableData="tableData"
                    :onMap="true"

        >                       
        </component>
        <div v-if="dataRow && dataRow.additionalMapPinInfo">
            <div v-for="(value, index) in dataRow.additionalMapPinInfo">
                {{index}}:{{value}}    
            </div>
        </div>
  </div>
</template>
<script>
    export default {
      props: ['title','lat', 'long', 'displayComponent', 'displayComponentProps',
        'showDisplayComponent', 'dataRow', 'tableData', 'parent', 'menuTable', 'index', 'searchCoord'],
      data() {
        return {
        }
      },
      mounted() {
        console.log('oxgenmappin', 'mounted', 'title:', this.title);
        window._mappin = this;
        this.$nextTick(function(){
        });
      },
      methods: {
        rightMenuClick() {
          this.menuTable.rightMenuClick(this.dataRow, null, this.$refs.rightMenuIcon);
        }
      }
    }
</script>